import { apiFetch } from "@/lib/api-fetch";

export async function getOrCreateDirectConversationAction(
  otherUserId: string
): Promise<{ conversationId: string }> {
  const res = await apiFetch("/api/conversations/direct", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ otherUserId }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { error?: string }).error || "Failed");
  }
  return (await res.json()) as { conversationId: string };
}

export async function sendMessageAction(
  conversationId: string,
  message: string
): Promise<{ success: boolean }> {
  const res = await apiFetch(
    `/api/conversations/${encodeURIComponent(conversationId)}/messages`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message }),
    }
  );
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { error?: string }).error || "Failed");
  }
  return { success: true };
}

export async function markConversationReadAction(conversationId: string): Promise<{ success: boolean }> {
  const res = await apiFetch(`/api/conversations/${encodeURIComponent(conversationId)}/read`, {
    method: "PATCH",
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { error?: string }).error || "Failed");
  }
  return { success: true };
}
